import { useMutation } from '@tanstack/react-query';

import { api } from '@/lib/api';

interface PreRegistrationDate {
  title: string;
  date: string;
}

interface PreRegistrationWishlistItem {
  title: string;
  description?: string;
  link?: string;
}

interface PreRegistrationRequest {
  email: string;
  name: string;
  dates: PreRegistrationDate[];
  wishlist_items?: PreRegistrationWishlistItem[];
  invite_token?: string;
}

export function usePreRegistration() {
  return useMutation({
    mutationFn: async (data: PreRegistrationRequest) => {
      await api.post('pre-registration', { json: data });
    },
  });
}
